var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 86.1 61.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Nepojmenovan\\xFD_p\\u0159echod_77",
    x1: 36.28,
    y1: 126.49,
    x2: 53.83,
    y2: 114.28,
    gradientTransform: "translate(138.15 11.43) rotate(93.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#33203f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#770070"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.06,42.54s-1.27,9.63,8.03,13.18c9.3,3.55,19.39-3.88,19.39-3.88l-1.42-9.38-26,.08Z",
    style: {
      fill: "url(#Nepojmenovan\xFD_p\u0159echod_77)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,24.57s-7.55,8.67-14.35,14.37c-6.8,5.7-15.37,10.75-19.26,11.73-6.51,1.64-8.52-3.79-8.52-3.79,0,0,.02,2.87.88,4.1s2.66,2.71,3.47,3.62,3.52,1.48,3.52,1.48l4.84-1.38,28.06-19.65,4.53-6.34-.07-2.02-3.11-2.12Z",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.43 12.49 86.1 3.02 83.21 0 28.02 16.22 29.97 19.35 32.43 20.18 78.43 12.49",
    style: {
      fill: "#a40064",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,54.15L86.1,3.02,29.97,19.35l14.25,7.17s-11.56,13.72-23.37,21.13c-11.14,7-16.01,7.23-19.44,3.62,0,0,4.6,5.76,10.01,7.72,6.06,2.2,14.44,4.4,26.06.02,11.61-4.37,19.36-9.53,22.52-11.91,3.16-2.38,6.71-4.9,6.71-4.9l6.89,11.94Z",
    style: {
      fill: "#daff06",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.37,54.35c4.6,3.11,15.15,6.8,37.3-7.8C66.17,30.39,77.66,14.55,86.05,3.23l.05-.21L29.97,19.35l14.25,7.17s-11.56,13.72-23.37,21.13c-11.14,7-16.01,7.23-19.44,3.62,0,0,1.17,1.39,2.96,3.08Z",
    style: {
      fill: "#8cc63f",
      mixBlendMode: "multiply",
      opacity: 0.39,
      strokeWidth: 0
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrow);
export default __webpack_public_path__ + "static/media/menu-arrow.b33bc71e11e2d9d6a9db7c72644f415e.svg";
export { ForwardRef as ReactComponent };